import gql from 'graphql-tag';

export const CANCEL_RIDE_REQUEST = gql`
  mutation cancelRideRequest($id: ID!) {
    cancelRideRequest(id: $id)
  }
`;
